import { render, staticRenderFns } from "./ListRelease.vue?vue&type=template&id=78412b1c&scoped=true&"
import script from "./ListRelease.vue?vue&type=script&lang=js&"
export * from "./ListRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78412b1c",
  null
  
)

export default component.exports